import React from 'react';
import SignUpsV2Layout from './components/SignUpsV2Layout';
import PerformanceCardSkeleton from '../../components/PerformanceCardSkeleton';
import EntityCardSkeleton from '../../components/EntityCardSkeleton';

const TabSkeleton = () => (
  <>
    <PerformanceCardSkeleton />
    <div style={{ marginTop: 10 }}>
      <EntityCardSkeleton />
    </div>
  </>
);

const SignUpsV2Tab = ({
  signupsData,
  signupsLoading,
  signupsByDateData,
  chartLoading,
  onDateRangeChange,
  onAttrMethodChange,
  onAttrWindowChange,
  onPageChange,
  onPageSizeChange,
  currentPage,
  pageSize,
  dateRange,
  attrMethod,
  attrWindow,
  campaignOrder,
}) => {
  if (chartLoading) return <TabSkeleton />;

  return (
    <SignUpsV2Layout
      signupsData={signupsData}
      signupsLoading={signupsLoading}
      signupsByDateData={signupsByDateData}
      chartLoading={chartLoading}
      onDateRangeChange={onDateRangeChange}
      onAttrMethodChange={onAttrMethodChange}
      onAttrWindowChange={onAttrWindowChange}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      currentPage={currentPage}
      pageSize={pageSize}
      dateRange={dateRange}
      attrMethod={attrMethod}
      attrWindow={attrWindow}
      campaignOrder={campaignOrder}
    />
  );
};

export default SignUpsV2Tab;
